import { configureStore, createSlice } from '@reduxjs/toolkit'


// useState의 역할을 한다
let user = createSlice({
    name: 'user',
    initialState : {
        email : '',
        nikname: '',
        password: ''
    },
    reducers: {
        addUserEmail(state,action){
            state.email = action.payload          
        },
        addUserNikname(state,action){
            state.nikname = action.payload  
        },
        addUserPassword(state,action){
            state.password = action.payload  
        }
     }
})

export let {addUserEmail,addUserNikname,addUserPassword } = user.actions

let countPost = createSlice({
    name:'countPost',
    initialState:[],
    reducers: {
        addCount(state,action){
            state.unshift(action.payload)
        }
    }
})

export let {addCount} = countPost.actions

let postId = createSlice({
    name:'postId',
    initialState:[],
    reducers: {
        // 포스트 아이디 추가
        addPostId(state, action){
            console.log('포스트아이디추가')
            state.unshift(action.payload)
        },
        // 포스트 아이디 삭제
        deletePostId(state,action){
            console.log('포스트아이디삭제')
            state.splice(action.payload,1)
        }
        // 포스트 제목 수정
    }
})
export let {addPostId,deletePostId } = postId.actions


let postSub = createSlice({
    name:'postSub',
    initialState:[],
    reducers: {
        // 포스트 제목 추가
        addPostSub(state, action){
            state.unshift(action.payload)
        },
        // 포스트 제목 삭제
        deletePostSub(state,action){
            console.log('포스트제목삭제')
            state.splice(action.payload,1)
        },
        // 포스트 제목 수정
        editPostSub(state,action){
            console.log('포스트제목수정')
            state.splice(action.payload.arrayNumber,1,action.payload.postSub)
        }
    }
})
export let {addPostSub,deletePostSub,editPostSub } = postSub.actions

let post = createSlice({
    name:'post',
    initialState:[],
    reducers: {
        // 포스트 내용 추가
        addPost(state, action){
            state.unshift(action.payload)
        },
        // 포스트 내용 삭제
        deletePost(state, action){
            state.splice(action.payload,1)
        },
        // 포스트 내용 수정
        editPost(state,action){
            state.splice(action.payload.arrayNumber,1,action.payload.post)
        }
    }
})

export let {addPost,deletePost,editPost } = post.actions

let postDay = createSlice( {
    name:'postDay',
    initialState:[],
    reducers: {
        addPostDay(state,action){
            state.unshift(action.payload)
        },
        deletePostDay(state,action){
            state.splice(action.payload,1)
        }
    }
})
export let {addPostDay, deletePostDay} = postDay.actions


export default configureStore({
  reducer: {
        user:user.reducer,
        postSub:postSub.reducer,
        post:post.reducer,
        postId:postId.reducer,
        postDay:postDay.reducer,
        countPost:countPost.reducer
  }
}) 

